import { takeLatest, call, put } from 'redux-saga/effects'
import {
    chatListAPI, chatSendMessageAPI, messageListAPI
} from '../api-requests/chat';
import {
    chatListRequestError, chatListRequestSuccess, chatSendMessageRequestError,
    chatSendMessageRequestSuccess, messageListRequestError, messageListRequestSuccess
} from './chat.action';
import { ChatActionTypes } from './chat.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';

function* handleMessageList({ payload }) {
    try {
        const response = yield call(messageListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(messageListRequestSuccess(decryptedData))
            } else {
                yield put(messageListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(messageListRequestError(error.response.data))
    }
}

export function* messageListReq() {
    yield takeLatest(ChatActionTypes.MESSAGE_LIST_REQUEST, handleMessageList)
}

function* handleChatSendMessage({ payload }) {
    try {
        const response = yield call(chatSendMessageAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(chatSendMessageRequestSuccess(decryptedData))
            } else {
                yield put(chatSendMessageRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(chatSendMessageRequestError(error.response.data))
    }
}

export function* chatSendMessageReq() {
    yield takeLatest(ChatActionTypes.CHAT_SEND_MESSAGE_REQUEST, handleChatSendMessage)
}

function* handleChatList({ payload }) {
    try {
        const response = yield call(chatListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(chatListRequestSuccess(decryptedData))
            } else {
                yield put(chatListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(chatListRequestError(error.response.data))
    }
}

export function* chatListReq() {
    yield takeLatest(ChatActionTypes.CHAT_LIST_REQUEST, handleChatList)
}